<nav>
  <ng-container *ngFor="let route of route.routeConfig?.children">
    <a
      *ngIf="isRouteVisible(route)"
      routerLinkActive="active"
      [routerLink]="route.path"
      queryParamsHandling="preserve">
      {{ route.title }}
    </a>
  </ng-container>
</nav>
